import type { IconProps } from "./icon-types";

/**
 * 정면 뇌(좌우 반구) 안에 회로 노드(도넛) 3개와 트레이스가 놓인 brain-circuit.
 * 머신러닝/모델/지능 계열 진입점에서 사용(제품 의미 부여는 소비 앱의 semantic alias 책임).
 *
 * Fluent UI System Icons `brain-circuit-24-regular`(MIT) path 를 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 24 그리드 / fill 기반.
 */
export const BrainCircuitIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M14.5 2a3.25 3.25 0 0 1 3.218 2.795a3.876 3.876 0 0 1 2.08 6.633A4 4 0 0 1 22 15v.25a4 4 0 0 1-3.367 3.95c-.431 1.613-1.901 2.8-3.627 2.8c-1.228 0-2.32-.59-3.006-1.504A3.75 3.75 0 0 1 8.994 22c-1.726 0-3.195-1.187-3.627-2.8A4 4 0 0 1 2 15.25V15a4 4 0 0 1 2.2-3.572a3.876 3.876 0 0 1 2.082-6.633A3.25 3.25 0 0 1 12 3.174A3.24 3.24 0 0 1 14.5 2m-5 1.5a1.75 1.75 0 0 0-1.75 1.75v.25a.75.75 0 0 1-.75.75h-.125a2.375 2.375 0 1 0 0 4.75H7a2.25 2.25 0 0 1 2.238 2.02l.012.23v.396a2 2 0 1 1-1.5 0v-.396l-.004-.077A.75.75 0 0 0 7 12.5H6A2.5 2.5 0 0 0 3.5 15v.25a2.5 2.5 0 0 0 2.5 2.5a.75.75 0 0 1 .719.542l.026.14h.002A2.276 2.276 0 0 0 8.994 20.5a2.255 2.255 0 0 0 2.256-2.25v-9h-.896a2 2 0 1 1 0-1.5h.896v-2.5A1.75 1.75 0 0 0 9.5 3.5m8.23 9a2 2 0 0 1-.98.852v.898a2.25 2.25 0 0 1-2.25 2.25h-1.75v1.75c0 1.24 1.011 2.25 2.256 2.25a2.276 2.276 0 0 0 2.247-2.068h.002l.026-.14A.75.75 0 0 1 18 17.75a2.5 2.5 0 0 0 2.5-2.5V15a2.5 2.5 0 0 0-2.5-2.5zM8.5 15a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m6-11.5a1.75 1.75 0 0 0-1.75 1.741V15h1.75a.75.75 0 0 0 .75-.75v-.898a1.999 1.999 0 1 1 2.646-2.483a2.374 2.374 0 0 0-.771-4.619H17a.75.75 0 0 1-.75-.75v-.25A1.75 1.75 0 0 0 14.5 3.5M16 11a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M8.5 8a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1" />
  </svg>
);
